import type { NodeType } from 'prosemirror-model';

import { NodeSelection, Plugin, TextSelection } from 'prosemirror-state';

export function preventNodeRemovalOnType(type: NodeType) {
  return new Plugin({
    props: {
      handleDOMEvents: {
        beforeinput(view) {
          const sel = view.state.selection;
          if (sel instanceof NodeSelection && sel.node.type === type) {
            const posAfter: number = sel.$to.pos;
            view.dispatch(view.state.tr.setSelection(TextSelection.create(view.state.doc, posAfter)));
            return false;
          }
          return false;
        },
      },
      handleTextInput(view, _from, _to, text) {
        const sel = view.state.selection;
        if (sel instanceof NodeSelection && sel.node.type === type) {
          const posAfter: number = sel.$to.pos;
          view.dispatch(view.state.tr.setSelection(TextSelection.create(view.state.doc, posAfter)).insertText(text).scrollIntoView());
          return true;
        }
        return false;
      },
      handlePaste(view, _event, slice) {
        const sel = view.state.selection;
        if (sel instanceof NodeSelection && sel.node.type === type) {
          const posAfter: number = sel.$to.pos;
          view.dispatch(view.state.tr.setSelection(TextSelection.create(view.state.doc, posAfter)).replaceSelection(slice).scrollIntoView());
          return true;
        }
        return false;
      },
    },
  });
}
